import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { Form } from '../../../../components/general/general-component/abstruct-component/AbstructForm';
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { VariableSubCategory } from './VariableSubCategory';
import SelectDropDown from '../../../../components/elements/SelectDropDown';
import { loadCategories } from '../../../../store/Actions/ActionCategory';
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom';
import { putSubCategory } from '../../../../store/Actions/ActionSubCategory';

function EditSubCategory({ arr, open, setOpen }) {
    const { categories } = useSelectorCustom()
    const [option,setOption] = useState([])
    const { mode, dispatch, navigate, langLocal } = AbstructVar();
    const { translate } = AbstructLang();
    const { state, setStateCustom, setLoad, setState } = VariableSubCategory();
    useEffect(() => {
        dispatch(loadCategories())
    }, []);
    useEffect(() => {
        setOption(categories?.map((category)=>({
            value: category?.id,
            label: category?.name
        })))
    }, [categories]);
    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            name: arr.name,
            description: arr.description,
            category: arr.material_category_id,
            category_name: arr?.material_category?.name,
        }));
    }, [arr]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(putSubCategory(arr.id, state.name, state.description, state.category, setLoad));
    };
    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
        { name: 'description', label: 'description', type: 'text', inputType: 'text', iconType: "pencil" },
    ];

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: 'popupR',
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
                <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
                    <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('edit-sub-category')}</p>
                </div>
                <div className='select-in-form' >
                    <p className={langLocal === 'ar'? "textAlignRight": ""} >{translate('category')}</p>
                    <SelectDropDown options={option}
                        defaultvalue={{value: state.category , label: state.category_name}}
                        varr={state.category}
                        setVarr={(value) => setStateCustom('category', value)} />
                </div>
                <div style={{ marginTop: "-10px" }} >
                    <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} translate={translate} buttonLabel="edit" />
                </div>
            </div>
        </RModal>
    );
}

export default EditSubCategory;

